import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PopupService } from 'src/app/common/services/popup/popup.service';


@Component({
  selector: 'app-applicant-type-alert',
  templateUrl: './applicant-type-alert.component.html',
  styleUrls: ['./applicant-type-alert.component.scss']
})
export class ApplicantTypeAlertComponent  {

  constructor(
    @Inject(MAT_DIALOG_DATA) protected dialogData: any,
    private _popupService:PopupService
  ) { }

  closeAlert(action: string = ''){
    this._popupService.getModelInstance().close({
      result: action
    });
  }

}
/****
 selectApplicantType(product:string){
  let _component = this._popupService.getComponent('applicant-type');
  let modal = new FpxModal();
  modal.setAutoFocus(true);
  modal.setBackDropClass('backdrop');
  modal.setWidth('');
  modal.setHeight('');
  modal.setPanelClass('alert-modal');
  modal.setComponent(_component);
  modal.setData({
    routingParams: {}
  });
  modal.setAfterClosed(this._modelAfterClose);
  this._popupService.openModal(modal);
}

 private _modelAfterClose = (payload: FpxModalAfterClosed) => {
    console.log('form pop up action triggered in After Close event', payload);
    let result = payload['result'];
    if(result == 'newApplicant'){
      this._router.navigate(['default-shell', 'rm', 'product-selection']);
    } else if(result == 'existingCustomer'){
       this._router.navigate(['default-shell', 'rm', 'bbn']);
    } else {

    }
  }
****/
